// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'MatterMedium', 'MatterMedium Fallback'"},"className":"__className_ef8b7b","variable":"__variable_ef8b7b"};